import React from 'react';
import PropTypes from 'prop-types';
import { ErrorMessage as HookFormErrorMessage } from '@hookform/error-message';
import { bem } from 'helpers/class-name';

import './ErrorMessage.scss';

const { block } = bem('hook-form-error');

function ErrorMessage(props) {
  const { name, className, errors } = props;

  return (
    <HookFormErrorMessage
      errors={errors}
      name={name}
      render={({ message: errorMessage }) => (
        <div className={block(className)} data-cypress="form-field-error">
          {errorMessage}
        </div>
      )}
    />
  );
}

ErrorMessage.propTypes = {
  className: PropTypes.string,
  name: PropTypes.string,
  errors: PropTypes.shape({}),
};

export default ErrorMessage;
